import React from "react";

interface NewMessagesIndicatorProps {
  count: number;
  onJump: () => void;
}

export function NewMessagesIndicator({ count, onJump }: NewMessagesIndicatorProps) {
  if (count <= 0) return null;

  const label = count === 1 ? "1 new message" : `${count} new messages`;

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-3 flex justify-center z-10">
      <button
        type="button"
        onClick={onJump}
        className="pointer-events-auto rounded-full border-2 border-ink bg-paper px-3 py-1.5 text-xs font-bold shadow-brutal-sm hover:bg-accent/15 transition-colors"
      >
        {label} ↓
      </button>
    </div>
  );
}
